import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import { Switch, Route, withRouter } from 'react-router-dom';
import 'moment/locale/pt';
import InsightcareFooter from './components/InsightcareFooter';
import AuxRoutines from './AuxRoutines';
//require('moment/locale/pt-BR');
import { BACKEND_URL } from './config/constants';

class PainelInternacao extends Component {

  constructor(props) {
    super(props);
    const { match: { params } } = this.props;
    console.log(params);
    this.state={
      cycle:0,
      totalCycles:0,
      pacientes: [],
      numberOfElements: 0,
      base: params.base,
      company: params.company,
      unidade: params.unidade,
      unidadeDescricao: 'Unidade de Internação',
      locationName: AuxRoutines.getLocationName(params.base,params.company)
    };
    this.loadRequiredData = this.loadRequiredData.bind(this)
    setInterval(this.loadRequiredData, 20000);
		//setInterval(this.loadRequiredData, 5000);
    //this.randomize();
  }

  componentDidMount() {

    //Carrega o local se existe
    this.loadRequiredData().then(() => {
      this.setState({appIsReady: true});
    });
  }


  async loadRequiredData() {
    let sliceSize=9;

    moment.locale('pt');
    if (this.state.cycle===this.state.totalCycles) {
      let currentDateHour = moment().format('HH:mm | D [de] MMMM [de] YYYY');
      let pacientes = await this.requestData();
      let numberOfElements = pacientes.length;
      let cycle=1;
      let totalCycles=Math.ceil(numberOfElements/sliceSize);
      if (totalCycles==0) {
        cycle=0;
      }
      this.setState(
        {
          currentDateHour: currentDateHour,
          dashboardData: pacientes,
          pacientes: pacientes.slice(0, sliceSize),
          numberOfElements: numberOfElements,
          cycle: cycle,
          totalCycles: totalCycles,
        }
      );
    }else {
      if (this.state.totalCycles>0) {
        this.setState({cycle: this.state.cycle+1,pacientes: this.state.dashboardData.slice(0+(sliceSize*this.state.cycle), sliceSize+(sliceSize*this.state.cycle))})
      }
    }

  }

	async requestData() {
    let returnData=this.state.pacientes; //In case request fails
    //console.log(this.state.base)
    //let response = await axios.get('https://integracao.gruposanta.com.br/command-center/painel-urgencia?base='+this.state.base);
    //let url = 'http://localhost:8080/command-center/painel-urgencia?base='+this.state.base;
    let url = BACKEND_URL + '/command-center/painel-internacao?base='+this.state.base;
    if (this.state.company!==undefined && this.state.company!==null) {
      url=url+'&company='+this.state.company;
      if (this.state.unidade!==undefined && this.state.unidade!==null) {
        url=url+'&unidade='+this.state.unidade;
      }
    }
	  let response = await axios.get(url);
    
		//console.log(response.data);
    if (response.data && response.data.Status===true) {
      returnData=response.data.ResponseData;
    }
    return returnData;
  }
  
  render() {
    return (
      <div className="App">
        <header>
              <h1 id="title">{this.state.unidadeDescricao} - {this.state.numberOfElements} pacientes ({this.state.cycle}/{this.state.totalCycles})</h1>
              <img src="/img/logo.png" alt="InsightCare"/>
          </header>

          <main className="content" id="panel1">
              <table className="table table-striped">
                <thead>
                  <tr>
                      <th width="1%"></th>
                      <th width="10%" style={{textAlign: 'center'}}>
                          <img src="/img/icon_status.svg" alt=""/>Leito
                      </th>
                      <th width="20%" style={{textAlign: 'center'}}>
                          <img src="/img/icon_patient.svg" alt=""/>Paciente
                      </th>
                      <th width="20%" style={{textAlign: 'center'}}>
                          <img src="/img/icon_patient.svg" alt=""/>Especialidade
                      </th>
                      <th width="20%" style={{textAlign: 'center'}}>
                          <img src="/img/icon_patient.svg" alt=""/>Médico
                      </th>
                      <th width="15%">
                           <img src="/img/icon_status.svg" alt=""/>Previsão Alta
                       </th>
                      <th width="14%" style={{textAlign: 'center'}}>
                          <img src="/img/icon_status.svg" alt=""/>Duração
                      </th>
                  </tr>
                </thead>
                <tbody>
                {this.state.pacientes.map((data) => {
                    let statusClass="ready";
                    let tdClassLab="";
                    let spanClassLab="";
                    let tdClassRx="";
                    let spanClassRx="";
                    let spanClassFarm="";
                    let name = data.NOMEPACIENTE.trim().split(' ').slice(-1).join(' ') + ', ' + data.NOMEPACIENTE.trim().split(' ')[0].slice(0,1);
                    let leito=data.DESCRICAOLEITO;
                    let medico = data.NOMEPRESTADOR.trim().split(' ')[0] + ' ' + data.NOMEPRESTADOR.trim().split(' ').slice(-1).join(' ');
                    let especialidade = data.DESCRICAOESPECIALIDADE;
                    let previsao = data.DATAPREVISTAALTA;
                    let time=data.DURACAOATENDIMENTO;
                    if (this.state.unidadeDescricao==='Unidade de Internação' && this.state.unidade!==undefined && this.state.unidade!==null && data.DESCRICAOUNIDADEINTERNACAO!==null && data.DESCRICAOUNIDADEINTERNACAO!=='') {
                      this.setState({
                        unidadeDescricao: data.DESCRICAOUNIDADEINTERNACAO
                      });
                    }

                    if (data.TEMPOALTA!==undefined && data.TEMPOALTA!==null && data.TEMPOALTA>=0) {
                      if (data.TEMPOALTA==0) {
                        previsao="Hoje";

                      }else {
                        previsao=data.TEMPOALTA + ' dias';
                      }
                    }

                    time=Math.ceil(time) +' dias';
                    

                    return (
                      <tr key={this.state.Paciente} className={statusClass}>
                          <td><div className="alert-label"></div></td>
                          <td>{leito}</td>
                          <td><b>{name}</b></td>
                          <td className={tdClassLab}><span className={spanClassLab}></span>{especialidade}</td>
                          <td className={tdClassRx}><span className={spanClassRx}></span>{medico}</td>
                          <td className={tdClassRx}><span className={spanClassFarm}></span>{previsao}</td>
                          <td><b>{time}</b></td>
                      </tr>
                    )
                  })
                }

                </tbody>
              </table>
          </main>



      </div>
    );
  }

}

export default PainelInternacao;
